import pageView from './appEvents/pageViewEvents';
import popupOpen from './appEvents/popupOpenEvents';
import buttonClick from './appEvents/buttonClickEvents';
import pillClick from './appEvents/pillClickEvents';
import errorMsg from './appEvents/errorMsgEvents';
import scroll from './appEvents/scrollEvents';

const events = {
  pageView,
  popupOpen,
  buttonClick,
  pillClick,
  errorMsg,
  scroll,
};

export default events;
